<template>
  <transition name="glass-drawer">
    <div class="glass-drawer-wrapper" v-if="show">
      <div class="glass-drawer-overlay" @click="$emit('close')"></div>
      <div class="glass-drawer" :style="{ width }">
        <div class="glass-title">
          <slot name="title-icon"></slot>
          <span>{{ title }}</span>
          <button class="glass-close" @click="$emit('close')" aria-label="关闭">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
        <div class="glass-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show:    { type: Boolean, default: false },
    title:   { type: String,  default: '' },
    width:   { type: String,  default: '581px' },
  },
}
</script>

<style scoped lang="scss">
.glass-drawer-wrapper {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.glass-drawer-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  opacity: 1;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-drawer {
  position: relative;
  height: 100%;
  background: rgba(10, 22, 40, 0.88);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-left: 1px solid rgba(42, 98, 255, 0.12);
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 40px rgba(0,0,0,0.4);
  overflow: hidden;
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-title {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  color: var(--color-dark-text-accent, #8AB4FF);
  font-size: 15px;
  font-family: "AlibabaPuHuiTi-2-65-Medium", sans-serif;
  border-bottom: 1px solid rgba(42, 98, 255, 0.1);
  flex-shrink: 0;
}

.glass-close {
  margin-left: auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.35);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;

  &:hover {
    color: rgba(255, 255, 255, 0.85);
    background: rgba(255, 68, 68, 0.12);
  }
}

.glass-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Transition states */
.glass-drawer-enter-active,
.glass-drawer-leave-active {
  .glass-drawer-overlay {
    transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .glass-drawer {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
}

.glass-drawer-enter-from,
.glass-drawer-leave-to {
  .glass-drawer-overlay {
    opacity: 0;
  }
  .glass-drawer {
    transform: translateX(100%);
  }
}
</style>
